import { Suspense } from "react";
import * as React from "react";
import { Route } from "react-router-dom";
import { LazyLoading } from "../../controls/LazyLoading";
import HealthStatus from "../../pages/custom/health-status";
import GenericReport from "../../pages/report/genericReport";

// Lazy load Kentucky reports
const MechanicalActivity = React.lazy(
	() => import("../../pages/laboratory/kentucky/mechanical-activity"),
);
const MechanicalSampleByDate = React.lazy(
	() => import("../../pages/laboratory/kentucky/mechanical-sample-by-date"),
);
const MechanicalSampleByHeat = React.lazy(
	() => import("../../pages/laboratory/kentucky/mechanical-sample-by-heat"),
);

export const ReportRoutes = [
	<Route
		path="/report"
		element={
			<Suspense fallback={<LazyLoading></LazyLoading>}>
				<GenericReport />
			</Suspense>
		}
	></Route>,
	<Route
		path="/report/health-status"
		element={
			<Suspense fallback={<LazyLoading></LazyLoading>}>
				<HealthStatus />
			</Suspense>
		}
	></Route>,
	<Route
		path="/report/:reportCode"
		element={
			<Suspense fallback={<LazyLoading></LazyLoading>}>
				<GenericReport />
			</Suspense>
		}
	></Route>,
	<Route
		path="/report/:reportCode/:param1"
		element={
			<Suspense fallback={<LazyLoading></LazyLoading>}>
				<GenericReport />
			</Suspense>
		}
	></Route>,
	<Route
		path="/report/:reportCode/:param1/:param2"
		element={
			<Suspense fallback={<LazyLoading></LazyLoading>}>
				<GenericReport />
			</Suspense>
		}
	></Route>,
	<Route
		path="/report/:reportCode/:param1/:param2/:param3"
		element={
			<Suspense fallback={<LazyLoading></LazyLoading>}>
				<GenericReport />
			</Suspense>
		}
	></Route>,
	<Route
		path="/report/:reportCode/:param1/:param2/:param3/:param4"
		element={
			<Suspense fallback={<LazyLoading></LazyLoading>}>
				<GenericReport />
			</Suspense>
		}
	></Route>,
	<Route
		path="/report/:reportCode/:param1/:param2/:param3/:param4/:param5"
		element={
			<Suspense fallback={<LazyLoading></LazyLoading>}>
				<GenericReport />
			</Suspense>
		}
	></Route>,

	// Kentucky Reports Routes
	<Route
		path="/report/kentucky-mechanical-activity/:startDate/:endDate"
		element={
			<Suspense fallback={<LazyLoading></LazyLoading>}>
				<MechanicalActivity />
			</Suspense>
		}
	></Route>,
	<Route
		path="/report/kentucky-mechanical-activity"
		element={
			<Suspense fallback={<LazyLoading></LazyLoading>}>
				<MechanicalActivity />
			</Suspense>
		}
	></Route>,

	<Route
		path="/report/kentucky-mechanical-sample-by-date/:startDate/:endDate/:grade"
		element={
			<Suspense fallback={<LazyLoading></LazyLoading>}>
				<MechanicalSampleByDate />
			</Suspense>
		}
	></Route>,
	<Route
		path="/report/kentucky-mechanical-sample-by-date"
		element={
			<Suspense fallback={<LazyLoading></LazyLoading>}>
				<MechanicalSampleByDate />
			</Suspense>
		}
	></Route>,

	<Route
		path="/report/kentucky-mechanical-sample-by-heat/:heatId/:status/:validFlag"
		element={
			<Suspense fallback={<LazyLoading></LazyLoading>}>
				<MechanicalSampleByHeat />
			</Suspense>
		}
	></Route>,
	<Route
		path="/report/kentucky-mechanical-sample-by-heat"
		element={
			<Suspense fallback={<LazyLoading></LazyLoading>}>
				<MechanicalSampleByHeat />
			</Suspense>
		}
	></Route>,
];
